export const ACCESS_SUSPENDED_PATH = 'access-suspended';
export const ACCESS_SUSPENDED_PAGE = `/${ACCESS_SUSPENDED_PATH}`;
